// src/pages/Auth/InstagramCallback.js
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exchangeInstagramCode } from "../../utils/instagramAuth";

const InstagramCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState("Processing...");

    useEffect(() => {
        const code = searchParams.get("code");
        const error = searchParams.get("error");
        const errorReason = searchParams.get("error_reason");
        const errorDescription = searchParams.get("error_description");

        if (code) {
            console.log("Instagram Auth Code:", code);
            setStatus("Verifying connection...");

            // Simulate exchange
            exchangeInstagramCode(code)
                .then((response) => {
                    console.log("Exchange response:", response);
                    // In real implementation, save the token/status to Context or Firestore here

                    // Successful connection, redirect back to onboarding
                    // We assume we want to go back to Brand Boarding, explicitly Step 3 or 4
                    // Passing a state or query param could help restore the step

                    // For now, we'll store a flag in localStorage to indicate success for the onboarding page
                    localStorage.setItem("instagram_connected", "true");

                    setTimeout(() => {
                        navigate("/onboarding/brand");
                    }, 1000);
                })
                .catch((err) => {
                    console.error("Exchange error:", err);
                    setStatus("Connection failed. Please try again.");
                });

        } else if (error) {
            console.error("Instagram Auth Error:", error, errorReason, errorDescription);
            setStatus(`Connection failed: ${errorDescription || "Unknown error"}`);
        } else {
            setStatus("No code returned.");
        }
    }, [searchParams, navigate]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#fffaf5]">
            <div className="p-8 bg-white shadow-lg rounded-2xl text-center">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">Instagram Connection</h2>
                <div className="flex justify-center mb-4">
                    {/* Simple spinner */}
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink-500"></div>
                </div>
                <p className="text-gray-600">{status}</p>
            </div>
        </div>
    );
};

export default InstagramCallback;
